import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import type { PersonalizedTasksStatus } from '@change-corgi/middle-end-gql-schema';

import {
	SAPPersonalizedTasksGenStatus,
	type SapPersonalizedTasksGenStatusQuery,
	type SapPersonalizedTasksGenStatusQueryVariables,
} from './personalizedTasksGenStatus.graphql';
import {
	SAPStartStrongAfterSapAssignment,
	type SapStartStrongAfterSapAssignmentQuery,
	type SapStartStrongAfterSapAssignmentQueryVariables,
} from './startStrongAfterSapAssignment.graphql';

type StartStrongAfterSapAssignment =
	SapStartStrongAfterSapAssignmentQuery['experiments']['starterExperienceStartStrongAfterSapV3'];

/** Resolves `null` when the status can't be read, so callers treat it as "not decided yet". */
export async function fetchPersonalizedTasksGenStatus({
	petitionId,
	utilityContext,
}: {
	petitionId: string;
	utilityContext: UtilityContext;
}): Promise<PersonalizedTasksStatus | null> {
	const { data } = await utilityContext.gql.fetch<
		SapPersonalizedTasksGenStatusQuery,
		SapPersonalizedTasksGenStatusQueryVariables
	>({
		query: SAPPersonalizedTasksGenStatus,
		variables: { petitionId },
		rejectOnError: true,
	});

	const personalizedTasks = data.petition?.personalizedTasks;
	if (personalizedTasks?.__typename !== 'PersonalizedTasksSuccess') return null;

	return personalizedTasks.status;
}

/** Reads the assignment without treating; petition_service owns this experiment's exposure. */
export async function fetchStartStrongAfterSapAssignment(
	utilityContext: UtilityContext,
): Promise<StartStrongAfterSapAssignment> {
	const { data } = await utilityContext.gql.fetch<
		SapStartStrongAfterSapAssignmentQuery,
		SapStartStrongAfterSapAssignmentQueryVariables
	>({
		query: SAPStartStrongAfterSapAssignment,
		rejectOnError: true,
	});

	return data.experiments.starterExperienceStartStrongAfterSapV3;
}
